/**
 * the current Map Projection
 */
export const MAP_PROJECTION = 'EPSG:3857';
